module.exports = __webpack_public_path__ + "img/ntd-no-text.26c1d160.svg";